import gql from 'graphql-tag'

export const GET_EMPLOYEES = gql`
  query Employees($filter: GetEmployeesInput) {
    employees(filter: $filter) {
      isSuccessful
      message
      employees {
        userId
        canLogin
        fullname
        gender
        maritalStatus
        address
        email
        employeeIdentifier
        phoneNo
        birthdate
        birthplace
        inactiveCause
        inactiveOn
        language
        driverQualifications
        photograph
        bankAccount
        recruitedAt
        isActive
        isDriver
        isEmployee
        joinOn
        identification {
          methods {
            rfid
            faceRecognition
          }
          vehicles {
            vehicleId
            licensePlate
            methodStatuses {
              rfid
              faceRecognition
            }
          }
        }
        groups {
          id
          name
          vgroups {
            id
            name
          }
        }
        userDocs {
          fullname
          userId
          docType
          docNumber
          validUntil
        }
        position {
          name
          departmentName
          structureId
          unitName
        }
      }
    }
  }
`

export const GET_EMPLOYEES_PAGINATED = gql`
  query EmployeesPaginated($filter: GetEmployeesWithPaginationInput) {
    employeesPaginated(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      employeesPaginated {
        data {
          fullname
          userId
          email
          employeeIdentifier
          phoneNo
          position {
            companyId
            name
            unitName
            departmentId
            departmentName
            unitId
          }
          photograph
          isActive
          identification {
            methods {
              rfid
              faceRecognition
            }
            vehicles {
              vehicleId
              licensePlate
              methodStatuses {
                rfid
                faceRecognition
              }
            }
          }
          groups {
            name
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_DETAIL_EMPLOYEE = gql`
  query Employee($filter: GetEmployeeInput!) {
    employee(filter: $filter) {
      isSuccessful
      message
      employee {
        userId
        fullname
        gender
        maritalStatus
        address
        email
        employeeIdentifier
        phoneNo
        birthdate
        birthplace
        inactiveCause
        inactiveOn
        language
        driverQualifications
        photograph
        bankAccount
        recruitedAt
        isActive
        isEmployee
        isDriver
        joinOn
        isEmailVerified
        isPhoneVerified
        identification {
          methods {
            rfid
            faceRecognition
          }
          vehicles {
            vehicleId
            licensePlate
            methodStatuses {
              rfid
              faceRecognition
            }
          }
        }
        groups {
          id
          name
          vgroups {
            id
            name
          }
        }
        userDocs {
          fullname
          userId
          docType
          docNumber
          validUntil
        }
        position {
          name
          departmentName
          structureId
          unitId
          departmentId
          unitName
        }
        userWorkHistory {
          userWorkHistoryId
          userId
          companyName
          position
          joinedOn
          leftOn
        }
        vehicleCategories
      }
    }
  }
`

export const CREATE_EMPLOYEE = gql`
  mutation CreateEmployee($input: CreateEmployeeInput!) {
    createEmployee(input: $input) {
      isSuccessful
      message
      employee {
        userId
        identification {
          methods {
            rfid
            faceRecognition
          }
          vehicles {
            vehicleId
            licensePlate
            methodStatuses {
              rfid
              faceRecognition
            }
          }
        }
      }
    }
  }
`

export const UPDATE_EMPLOYEE = gql`
  mutation UpdateEmployee($input: UpdateEmployeeInput!) {
    updateEmployee(input: $input) {
      isSuccessful
      message
      employee {
        userId
        identification {
          methods {
            rfid
            faceRecognition
          }
          vehicles {
            vehicleId
            licensePlate
            methodStatuses {
              rfid
              faceRecognition
            }
          }
        }
      }
    }
  }
`

export const IMPORT_EMPLOYEE = gql`
  mutation ImportEmployees($input: ImportEmployeeInput!) {
    importEmployees(input: $input) {
      isSuccessful
      message
      importEmployees {
        totalSuccess
        totalFailed
        totalData
        errorFile
      }
    }
  }
`

export const SUMMARY_TRIP_DRIVER = gql`
  query SummaryTripDriver($filter: SummaryTripDriverFilter) {
    summaryTripDriver(filter: $filter) {
      isSuccessful
      message
      summaryTripDriver {
        summaryTrips {
          vehicleId
          tripMileage
          startLong
          startLat
          stopLong
          stopLat
          maxSpeed
          vehicle {
            licensePlate
          }
          startTime
          stopTime
          totalHourStart
          totalHourStop
        }
        totalTrip
        totalHourStart
        totalHourStop
        motionStatus
      }
    }
  }
`

export const LAST_SUMMARY_TRIP_DRIVER = gql`
  query LastSummaryTripDriver($filter: LastSummaryTripDriverFilter) {
    lastSummaryTripDriver(filter: $filter) {
      isSuccessful
      message
      lastSummaryTripDriver {
        summaryTrips {
          vehicleId
          tripMileage
          startLong
          startLat
          stopLong
          stopLat
          maxSpeed
          vehicle {
            licensePlate
          }
          startTime
          stopTime
          totalHourStart
          totalHourStop
        }
        totalTrip
        totalHourStart
        totalHourStop
        motionStatus
      }
    }
  }
`

export const GET_EMPLOYEE_UPLOAD_HISTORY = gql`
  query ImportHistories($filter: ImportHistoriesFilter) {
    importHistories(filter: $filter) {
      isSuccessful
      message
      importHistories {
        users {
          fullname
        }
        importOn
        totalFailed
        totalSuccess
        model
        filename
      }
    }
  }
`

export const GET_DRIVER_FILTER = gql`
  query DriversFilter($filter: DriversPaginatedFilters) {
    driversFilter(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      driversFilterPaginated {
        data {
          userId
          fullname
          employeeIdentifier
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
        ids
      }
    }
  }
`

export const GET_DRIVER_FILTER_ALL = gql`
  query Employees($filter: GetEmployeesInput) {
    employees(filter: $filter) {
      isSuccessful
      message
      employees {
        userId
        fullname
      }
    }
  }
`
